var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 120,
    height: 120,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_244_138",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_244_138",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACVUlEQVR4nO2aTU4CQRSEnxfwDkzpTmYw3bDQxI3xaJqY+BNX4m3NW7gQ1InK9FT3qy/phEDoKvqbZoDBTAghhBBCCCGEEEIIIYQYZbFKN1imF/Tp7ZDDxO852WyOMeTXQ8uAhPxDSJ+3EkJEt1xfo0/P2iGVg1W++Gl3zd0vFBiRISEF6YZ0uS9jX07JTmHBlzsjb0+X6ysJIZJh/nihHTLFJ8Lq3nrHZDgSQiTDkRAiGY6EEMmYU0ht8xeR4UgIkQxHQohkOBJCJMORECIZjoQQyXAkhEiGIyFEMpxume4+5un6dGsT0eT3kO9+Qvf7/zxnn8/Q53sfftsmojkhh94ZpWlKSO0ymhLSgoxmhLQiowkhLcmoXkhrMqoW0qKMaoW0KqNKIS3LqE5I6zKqEhJBRjVCosioQkhpGdgpPPUYy5/69dHvDEgIjwxHQsjOGdAO+cxiSJtDX1z6jxArPP/c+bscdX1+mksGw4LMnb/LUTfkx7lkMCzI3Pl7nPT53KV0Q3pYrPLaCgMJ4QISwgUkhAtICBeQEC4gIVxAQriAhHABCeECEsIFJIQLSAgXkBAuICFcQEJ+XpBo//oA2/UQCUkSwnSEQkK4FgTsQkoXQvB8YyuE4PnGVgjB842tEILnG1shBM83tkIInm9shRA839gKIXi+sRVC8HxjK4Tg+cZWCMHzja0QgucbWyEEzze2Qgieb2yFEDzf2AoheL6xFULwfGMrhOD5xlYIwfONrRCC5xtbIQTPN7ZCCJ4/+oSph/JHkJA06wEpIWQHpLEVQvD8dwspWs66czkAAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.7195ff4e1b2cf0f5a7032c61527ece36.svg";
export { ForwardRef as ReactComponent };